module.exports = __webpack_public_path__ + "img/sx.053d83e2.png";